import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Instagram, Linkedin } from 'lucide-react';
import Logo from './Logo';

const Footer = () => {
  return (
    <footer className="bg-[#1A1410] text-white">
      {/* Retailers Section */}
      <div className="border-b border-gray-800 py-12">
        <div className="max-w-7xl mx-auto px-6">
          <p className="text-center text-gray-400 text-sm mb-8 uppercase tracking-wider">
            Available at Leading Retailers
          </p>
          <div className="flex justify-center items-center gap-12 flex-wrap grayscale opacity-60">
            <div className="text-4xl font-bold">Checkers</div>
            <div className="text-4xl font-bold">Pick n Pay</div>
            <div className="text-4xl font-bold">SPAR</div>
            <div className="text-4xl font-bold">Dis-Chem</div>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 mb-8">
            {/* Brand */}
            <div>
              <div className="mb-4">
                <Logo variant="light" />
              </div>
              <p className="text-gray-400 mb-4 text-sm">
                From sunrise, to beyond. Nutritious fuel for hours. Ready in seconds.
              </p>
              <div className="flex gap-2">
                <span className="px-2 py-1 bg-[#2C2416] rounded text-xs text-gray-400">RS</span>
                <span className="px-2 py-1 bg-[#2C2416] rounded text-xs text-gray-400">HF</span>
                <span className="px-2 py-1 bg-[#2C2416] rounded text-xs text-gray-400">GF</span>
              </div>
            </div>

            {/* Product */}
            <div>
              <h4 className="font-semibold mb-4 text-white">PRODUCT</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/" className="hover:text-[#C9A961] transition-colors">Overview</Link></li>
                <li><Link to="/nutrition" className="hover:text-[#C9A961] transition-colors">Nutrition</Link></li>
                <li><Link to="/nutrition" className="hover:text-[#C9A961] transition-colors">Buy GUAG</Link></li>
              </ul>
            </div>

            {/* Initiative */}
            <div>
              <h4 className="font-semibold mb-4 text-white">INITIATIVE</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/project" className="hover:text-[#C9A961] transition-colors">GUAG/PROJECT</Link></li>
                <li><Link to="/life" className="hover:text-[#C9A961] transition-colors">GUAG/LIFE</Link></li>
                <li><Link to="/project" className="hover:text-[#C9A961] transition-colors">Partner With Us</Link></li>
                <li><Link to="/project" className="hover:text-[#C9A961] transition-colors">Donate a Pack</Link></li>
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="font-semibold mb-4 text-white">COMPANY</h4>
              <ul className="space-y-2 text-gray-400 text-sm">
                <li><Link to="/about" className="hover:text-[#C9A961] transition-colors">About</Link></li>
                <li><Link to="/contact" className="hover:text-[#C9A961] transition-colors">Contact</Link></li>
                <li><a href="#privacy" className="hover:text-[#C9A961] transition-colors">Privacy Policy</a></li>
                <li><a href="#terms" className="hover:text-[#C9A961] transition-colors">Terms of Service</a></li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm">
              &copy; {new Date().getFullYear()} GUAG. All rights reserved.
            </p>
            <div className="flex gap-4">
              <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors">
                <Twitter size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors">
                <Instagram size={20} />
              </a>
              <a href="#" className="text-gray-400 hover:text-[#C9A961] transition-colors">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;